export default {"src":"/_next/static/media/terraced-icon-selected.96c67c0c.svg","height":86,"width":118,"blurWidth":0,"blurHeight":0};